import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { IconAlertTriangle } from '@tabler/icons-react'

import { useIdleMonitor } from '@/utils/hooks/useIdleMonitor'
import { unauthenticateUser } from '@/reducers/auth/currentUser.actions'
import { BroadcastClient } from '@/utils/classes/BroadcastClient'
import { setPrompt } from '@/reducers/ui/ui.redux'

export const IdleMonitorProvider = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const sessionBroadcast = new BroadcastClient('session-broadcast')
  const { currentOrganization } = useSelector((state) => state)
  const { user_id: userId } = useSelector((state) => state.currentUser)
  const enableIdleMonitor = currentOrganization.session_timeout_enabled || false

  const onPrompt = (data) => {
    dispatch(setPrompt(data))
  }

  const afterSessionExpired = () => {
    onPrompt({
      header: 'Session expired',
      content: 'Your session has expired due to inactivity. Please log in again.',
      critical: true,
      icon: <IconAlertTriangle />,
    })
  }

  const onSessionExpired = () => {
    history.push('/login')

    if (history.location.pathname === '/login') {
      dispatch(unauthenticateUser({ history })).then(() => {
        afterSessionExpired()
      })
    }
  }

  useIdleMonitor(userId, sessionBroadcast, onSessionExpired, onPrompt, enableIdleMonitor)

  return null
}
